import CustomCollapse from "../../../../../components/generic/CustomDetails";
import dayjs from "../../../../../utils/dayjs";

const Summary = ({ data }) => {
  const {
    short_summary = "",
    key_points = [],
    action_items = [],
    participant_summary = {},
    sentiment = "neutral",
  } = data?.summary_text || data || {};

  return (
    <CustomCollapse
      title={dayjs(data.created_at).format("DD MMM YYYY · HH:mm")}
      id={data.id}
      //@ts-ignore
      headerRight={
        <span className={`sentiment-badge s-${sentiment || "positive"}`}>
          {sentiment || "Positive"}
        </span>
      }
    >
      <div className="card-body" id="card-c1">
        <div className="section">
          <div className="label">Summary</div>
          <div className="short-summary">{short_summary}</div>
        </div>
        {!!key_points?.length && (
          <div className="section">
            <div className="label">Key points</div>
            <div className="chips">
              {key_points?.map((p) => (
                <span className="chip">{p}</span>
              ))}
            </div>
          </div>
        )}

        {!!action_items?.length && (
          <div className="section">
            <div className="label">Action items</div>
            {action_items?.map((item) => (
              <div className="action-item">
                <div
                  className={`priority-dot ${item?.priority || "high"}`}
                ></div>
                <div>
                  <div className="action-who">
                    {item.who_name} · {item.who}
                  </div>
                  <div className="action-what">{item.what}</div>
                  <div className="action-due">
                    {dayjs(item.due_date).format("DD MMM YYYY · HH:mm")}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="section">
          <div className="two-col">
            {!!participant_summary?.customer_concerns?.length && (
              <div>
                <div className="label">Customer concerns</div>
                {participant_summary?.customer_concerns?.map((cc) => (
                  <div className="concern-item">{cc}</div>
                ))}
              </div>
            )}
            {!!participant_summary?.advisor_commitments?.length && (
              <div>
                <div className="label">Advisor commitments</div>
                {participant_summary?.advisor_commitments?.map((ac) => (
                  <div className="concern-item">{ac}</div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </CustomCollapse>
  );
};

export default Summary;
